import React from 'react';
import Layout from '../../../layout/Layout';
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection';
import EditRuleForm from '../organisms/EditRuleForm';
import { useParams } from 'react-router-dom';

export default function EditRule() {
  const { id } = useParams();

  return (
    <Layout>
      <HeaderPageSection
        title="Editar regla"
        showGoBack={false}
        breadcrumbItems={[
          { label: 'Reglas', path: '/rules' },
          { label: 'Editar Regla', path: '#' },
        ]}
      />

      <div className="w-full">
        <EditRuleForm ruleId={Number(id)} />
      </div>
    </Layout>

  );
}

